var _defs, _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMicrosoftHtml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eeeded;}.cls-2{fill:#999;}.cls-3{fill:#d0614a;}.cls-4{fill:#fff;}.cls-5{fill:#b7b6b6;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.5 0.3 42.5 255.69 191.48 255.69 255.32 191.85 255.32 0.3 42.5 0.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.48 191.36 191.48 255.69 255.32 191.36 191.48 191.36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,154.9v72.93H170.14V154.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.74,169.3v16.38H37.82V169.3h8.64v42.84H37.82v-19H27.74v19H19.1V169.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78.74,176.38H69.38v35.76H60.74V176.38H51.38V169.3H78.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.68,169.3l6.12,30.24h.12l6.18-30.24h12.78v42.84H114v-34.2h-.12l-7.62,34.2H99.5l-7.62-34.2h-.12v34.2H83.84V169.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.26,169.3h8.64v35.76h15.3v7.08H129.26Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.93,70.67V81.83L97.51,94.16l30.42,12.33v10.89L82.4,98.93V89.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M164.11,51.41l-20.34,66.51H134L154,51.41Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.29,94.16,169.87,81.83V70.67l45.54,18.72v9.54l-45.54,18.45V106.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrosoftHtml);
export default __webpack_public_path__ + "static/media/icon-microsoft-html.86d70fe0.svg";
export { ForwardRef as ReactComponent };